@if (paperDocuments$ | async; as paperDocuments) {
  <div class="mt-4 w-18rem">
    @for (documentFileInfo of paperDocuments; track documentFileInfo; let last = $last) {
      <div>
        <sc-file-download [fileInfo]="documentFileInfo.file"
                          [download$]="downloadExpr(documentFileInfo.id)">
        </sc-file-download>
        @if (!last) {
          <p-divider></p-divider>
        }
      </div>
    }
  </div>
}